import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { getWorkspaceQuizzes } from '../../../api/workspaces/quiz';
import { WorkspaceQuiz } from '../../../api/workspaces/quiz/types';

export function useWorkspaceQuizzes<T = WorkspaceQuiz[]>({
  workspaceId,
  select,
  isDeleted,
  enabled = true,
}: {
  workspaceId: string;
  isDeleted?: boolean;
  select?: (workspaceQuizzes: WorkspaceQuiz[]) => T;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: workspaceKeys.quizzes({ workspaceId, isDeleted }),
    queryFn: () => getWorkspaceQuizzes({ workspaceId, isDeleted }),
    select,
    enabled,
  });
}
